// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // imageHost: 'https://ttd-api.onelink.co.th/',
  imageHost: 'https://qrpaybox.tomotek.vn/',
  // host: 'http://202.129.205.221:4002/api/v1/admin/',
  // host: 'http://192.168.0.46:8888/api/v1/', //Hung
  // host: 'http://192.168.101.30:8088/api/v1/', // Hoàng
  // imageHost: 'http://202.129.205.221:4002/',
  host: 'https://api-qrpayv2.tomotek.vn/api/v1/',
  // host: 'https://apiqrpay-dev.tomotek.vn/api/v1/',
  // host: 'http://192.168.0.100:8088/api/v1/',
  // https:ttd-api.onelink.co.th/api/v1/admin/auth/login
  // paydeeApiUrl: 'https://paydee-dev.tomotek.vn/',
  paydeeApiUrl: 'https://paydee.tomotek.vn/',
  defaultauth: 'fackbackend',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
0